import { installRegistryChartRebuild } from './charts/core/refresh';
import { syncActiveDashboardTheme, runWithDashboardTheme, dashboardPackFromApp } from './theme';
import { resolveEffectiveUiTokens } from '../components/nodeTheme';
var registry = {};
export function registerDashboard(type, factory) {
    registry[type] = factory;
}
export function createDashboardFromJSON(type, props, app) {
    var factory = registry[type];
    if (!factory)
        return null;
    var theme = syncActiveDashboardTheme(resolveEffectiveUiTokens(app, props), app, dashboardPackFromApp(app));
    return runWithDashboardTheme(theme, function () {
        var _a;
        var node = factory(props, app);
        if (node && 'children' in node && ((_a = node.metadata) === null || _a === void 0 ? void 0 : _a.widgetType) && !node.metadata.chartRebuild) {
            installRegistryChartRebuild(node, app, factory);
        }
        return node;
    });
}
export { registry };
